import * as React from 'react'

import { Ellipsis, Trash2 } from 'lucide-react'

import Localization from '../../localization/LocalizationManager'
import { Button } from '../Button/Button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../shadcn-ui/dropdown-menu'

interface IProps {
  /**
   * Invoked when the user picks Delete. The menu does NOT confirm — the caller
   * owns confirmation (e.g. a ConfirmDialog, or the map's delete dialog).
   */
  onDelete: () => void
}

/**
 * The resource card header's overflow menu: a 3-dot button that opens a
 * dropdown with a single destructive "Delete the resource" action.
 */
export const ResourceActionsMenu: React.FC<IProps> = ({ onDelete }) => (
  <DropdownMenu>
    <DropdownMenuTrigger
      render={
        <Button
          type="button"
          variant="ghost"
          size="icon-sm"
          aria-label={Localization.translator.actions}
          data-testid="resource-actions-menu"
        />
      }
    >
      <Ellipsis />
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end">
      <DropdownMenuItem variant="destructive" onClick={onDelete}>
        <Trash2 />
        {Localization.translator.delete}
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
)
